<template>
  <GmapMap :center="center" :zoom="zoom" :options="options" ref="map">
    <GmapCustomMarker
      v-for="(location, index) in locations"
      :key="index"
      :marker="location.location"
      :z-index="isLocationHighlighted(location) ? 100 : null"
      @mouseover.native="highlightLocation(location)"
      @mouseout.native="highlightLocation(false)"
      @click.native="goToLocation(location)"
    >
      <LocationLabel :location="location" :map="true" />
    </GmapCustomMarker>
  </GmapMap>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import GmapMap from 'vue2-google-maps/src/components/map'
import GmapCustomMarker from 'vue2-gmap-custom-marker'

import LocationLabel from '@/components/LocationLabel'

import mapConfig from '@/config/maps'

import EventBus from '@/util/event-bus'

export default {
  name: 'LocationMap',
  props: ['locations'],
  components: { GmapMap, GmapCustomMarker, LocationLabel },
  data() {
    return {
      center: mapConfig.defaultLocation,
      zoom: mapConfig.defaultZoom,
      options: {
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        styles: mapConfig.style
      }
    }
  },
  computed: {
    ...mapGetters(['isLocationHighlighted'])
  },
  mounted() {
    EventBus.$on('reset', () => {
      this.resetView()
    })
  },
  methods: {
    ...mapActions(['highlightLocation']),
    getMap() {
      return this.$refs.map.$mapPromise
    },
    panTo(position) {
      this.getMap().then((map) => {
        map.panTo(position)
      })
    },
    resetView() {
      this.getMap().then((map) => {
        map.panTo(mapConfig.defaultLocation)
        map.setZoom(mapConfig.defaultZoom)
      })
    },
    goToLocation(location) {
      this.scrollToLocationInContent(location)
      // this.panTo(location.location)
    },
    scrollToLocationInContent(location) {
      const selector = `main [data-location-scroll-anchor='${location._id}']`
      const content = document.querySelector(selector)
      if (content) {
        content.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
      }
    }
  }
}
</script>

<style scoped>
.vue-map-container {
  width: 100%;
  height: 100%;
}
</style>
